import React, { useContext, useState } from "react";
import logo from '../Assets/Images/Caduceus 512x512.gif'
import { IoMdCloseCircle } from "react-icons/io";
import Modal from 'react-bootstrap/Modal';
import { ReactComponent as Logout } from "../Assets/Images/SidebarIcons/SignOut.svg";
import { ProfileContext } from "../context/ProfileContext";
import { useLocation, useNavigate } from "react-router-dom";
import { menuItems } from "../utils/menuItems";
import axios from "axios";
import { BASE_URL, LOGOUT } from "../API";

function Sidebar() {
  const { personalInfo, headers, resetProfileContext } = useContext(ProfileContext);
  const [show, setShow] = useState(false);
  const handleLogout = async () => {
    setShow(false);
    localStorage.removeItem('token');
    await axios.post(BASE_URL + LOGOUT, {}, { headers });
    resetProfileContext()
    navigate('/');
  }
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const navigate = useNavigate();
  const location = useLocation()
  const [isToggled, setIsToggled] = useState(false);
  const handleToggle = () => { setIsToggled((prev) => !prev); };

  const hasAccess = (item) => {
    if (item.adminOnly && personalInfo?.role !== "ADMIN") return false;
    else if (item.doctorOnly && personalInfo?.role === "ADMIN") return false;
    return true;
  };

  return (
    <div className={`sidebar col-3  ${isToggled ? 'active-sidebar' : ''}`}>

      <div className="toggl-main" onClick={handleToggle}><i className="fa-solid fa-bars"></i></div>
      <div className="sidebar-wrapper d-flex hide-scrollbar">
        <div className="sidebar-content">
          <div className="sidebar-logo">
            <figure className='text-center'>
              <img src={logo} onClick={() => navigate('/profile')} alt="logo" />
            </figure>
          </div>

          <ul className="slide-navli">
            {menuItems.filter(hasAccess).map(item => (
              <li key={item.path} onClick={() => navigate(item.path)}>
                <div className={location.pathname === item.path ? "inner-slide-li active" : "inner-slide-li"}>
                  <div className="selector-active">
                    <div className="top"></div>
                    <div className="bottom"></div>
                  </div>
                  {item.icon} <p>{item.label}</p>
                </div>
              </li>
            ))}

            {/* Logout button */}
            <li>
              <div className="inner-slide-li" onClick={handleShow}>
                <div className="selector-active">
                  <div className="top"></div>
                  <div className="bottom"></div>
                </div>
                <Logout />
                <p>Logout</p>
              </div>
            </li>
          </ul>
        </div>
        <Modal show={show} onHide={handleClose} centered className="comm_modal logout_modal">
          <Modal.Body className="p-0">
            <Modal.Header><IoMdCloseCircle onClick={handleClose} /></Modal.Header>
            <div className="comm_inner_body_modal">
              <h4>Are you sure you want to logout?</h4>
              <div className="modal_pair_btns">
                <button className='main-outline-btn' onClick={handleClose}>No</button>
                <button className='main-btn' onClick={handleLogout}>Yes</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>

    </div >
  )
}

export default Sidebar